let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("8qW90")).then(() => parcelRequire('1l5oU'));